import React, { useEffect, useState } from 'react';
import { Loader } from 'react-feather';
import PopupModal from '../../../Manage/PopupModal';
import ManageTable from '../../../Manage/ManageTable';

const OrderHistory = () => {
    const [loading, setLoading] = useState(true);
    const [tableData, setTableData] = useState([]);

    const [modal, setModal] = useState(false);
    const handleModal = () => setModal(!modal);

    const mockData = [
        {
            order_number: "#123456789",
            date_of_purchase: "30/04/2024",
            total_amount: "$150.00",
            status: "Approved"
        },
        {
            order_number: "#123456788",
            date_of_purchase: "30/04/2024",
            total_amount: "$75.00",
            status: "Pending"
        },
        {
            order_number: "#123456787",
            date_of_purchase: "30/04/2024",
            total_amount: "$200.00",
            status: "Replaced"
        },
        {
            order_number: "#123456787",
            date_of_purchase: "30/04/2024",
            total_amount: "$200.00",
            status: "Refunded"
        }
    ];

    useEffect(() => {
        // Simulate fetching data
        setTableData(mockData);
        setLoading(false);
    }, []);

    const columns = [
        {
            name: "Return Number",
            cell: (row) => <span title={row.order_number} className="ellipsis">{row.order_number}</span>,
            selector: (row) => row.order_number,
            sortable: true,
        },
        {
            name: "Date of Return",
            cell: (row) => <span title={row.date_of_purchase} className="ellipsis">{row.date_of_purchase}</span>,
            selector: (row) => row.date_of_purchase,
            sortable: true,
        },
        {
            name: "Refund",
            cell: (row) => <span title={row.total_amount} className="ellipsis">{row.total_amount}</span>,
            selector: (row) => row.total_amount,
            sortable: true,
        },
        {
            name: "Status",
            cell: (row) => (
                <span
                    title={row.status}
                    className="ellipsis"
                    style={{ color: row.status === 'Processing' ? '#EC7426' : row.status === 'Delivered' ? '#41B8E4' : '#6C757D' }}
                >
                    {row.status}
                </span>
            ),
            selector: (row) => row.status,
            sortable: true,
        },
    ];

    return (
        <>
            <div>
                {loading ? <Loader /> :
                    <ManageTable
                        name={'Return History'}
                        columns={columns}
                        setTableData={setTableData}
                        tableData={tableData}
                    />
                }
            </div>

            <PopupModal
                company_id={''}
                open={modal}
                setModal={setModal}
                handleModal={handleModal}
                name={''}
                tableData={''}
                setTableData={''}
            />
        </>
    );
}

export default OrderHistory;
